import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import styles from 'assets/styles/modal.module.scss';
import LoadingButton from 'components/loadingButton';
import dayjs from 'dayjs';
import { useState } from 'react';
import * as XLSX from 'xlsx';
import root from './styles.module.scss';

type Prop = {
  next: () => void;
  close: () => void;
  refetch: () => void;
  excelData: any;
  setExcelData: any;
};

export const UploadToExcel = ({ next, setExcelData, close, refetch }: Prop) => {
  // onchange states
  const [excelFile, setExcelFile] = useState<any>(null);
  const [typeError, setTypeError] = useState<any>(null);
  const [name, setName] = useState<string>('');

  // onchange event
  const handleFile = (e: any) => {
    let fileTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/csv',
    ];
    let selectedFile = e.target.files[0];

    if (selectedFile) {
      if (selectedFile && fileTypes.includes(selectedFile.type)) {
        setTypeError(null);
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = (e: any) => setExcelFile(e.target.result);
        setName(selectedFile.name);
      } else {
        setTypeError('Please select only excel file types');
        setExcelFile(null);
      }
    } else {
      setTypeError('Please select your file');
    }
  };

  function removeEmptyProperties(data: any) {
    return data.map((entry: any) => {
      const cleanedEntry: any = {};
      for (const key in entry) {
        if (entry.hasOwnProperty(key) && entry[key] !== '') {
          cleanedEntry[key.trim()] = entry[key]; // Trim key to remove leading or trailing spaces
        }
      }
      return cleanedEntry;
    });
  }


  const handleFileSubmit = (e: any) => {
    e.preventDefault();
    if (excelFile !== null) {

      const workbook = XLSX.read(excelFile, { type: 'buffer', cellDates: true }); 
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];
      const data = XLSX.utils.sheet_to_json(worksheet);


      const formatDate = (val: any) => {
        if (!val) return '';

        if (val instanceof Date) {
          return dayjs(val).format('DD/MM/YYYY');
        }
        return val; 
      };

      setExcelData(
        removeEmptyProperties(data).map((i: any) => ({
          // Use the helper for all date fields
          birth_date: formatDate(i['Дата рождения']),
          policy_start_date: formatDate(i['Дата начало']),
          policy_end_date: formatDate(i['Дата окончания']),
          address: i['Улица'],
          first_name: i['Имя'],
          last_name: i['Фамилия'],
          patronymic: i['Отчество'],
          region: i['Регион'],
          city: i['Город'],
          district: i['Район'],
          phone: i['Номер телефона'],
          gender: i['Пол'],
          policy_number: i['№ полиса'],
          insurance_program: i['Программа покрытия'],
          id: Math.floor(Math.random() * 1000000000),
        }))
      );
      next();
    } else {
      setTypeError('Please select your file');
    }
  };

  return (
    <Box className={root.container}>
      <form onSubmit={handleFileSubmit}>
        <Box className={root.content}>
          {name ? (
            <h1 className={root.title}>{name}</h1>
          ) : (
            <>
              <Typography className={root.title}>Загрузите файл .xlsx, .xls, .csv</Typography>
              <label htmlFor='file'>
                <Box className={root.uploadButton}>
                  <input hidden id='file' type='file' onChange={handleFile} />
                  Выберите файл
                </Box>
              </label>

              {typeError && (
                <div className={root.alert} role='alert'>
                  {typeError}
                </div>
              )}
            </>
          )}
        </Box>

        <Box className={styles.modalFooter}>
          <LoadingButton
            variant='cancel'
            onClick={() => {
              close();
              refetch();
            }}>
            Отменить
          </LoadingButton>
          <LoadingButton type='submit' variant='send'>
            Следующий
          </LoadingButton>
        </Box>
      </form>
    </Box>
  );
};
